import FetchStatus from '../Data/FetchStatus';

export const selectSubscriptionMatchStatus = (state) =>
  state.clientApiJourney?.subscriptionMatch?.status ?? FetchStatus.NOT_STARTED;

/**
 * Whether the pre-booking match check ruled the journey's subscription out:
 * anything but an explicit true once it completed, or a check that failed
 * (fail closed).
 */
export const selectHasSubscriptionMismatch = (state) => {
  const status = selectSubscriptionMatchStatus(state);
  if (status === FetchStatus.FAILED) return true;
  if (status !== FetchStatus.COMPLETED) return false;

  return state.clientApiJourney?.subscriptionMatch?.isMatched !== true;
};

/**
 * The predicate every booking dispatcher checks: the lead-status poll says the
 * lead can take a booking, and the match check says the subscription still
 * matches.
 */
export const selectIsBookingConfirmable = (state) =>
  state.clientApiJourney?.appointment?.isBookingConfirmable === true &&
  selectSubscriptionMatchStatus(state) === FetchStatus.COMPLETED &&
  state.clientApiJourney?.subscriptionMatch?.isMatched === true;
